// extracted by mini-css-extract-plugin
module.exports = {"instructions":"style__instructions__UCvU9","indent":"style__indent__eldVq","certificate":"style__certificate__ykapA"};